import React from 'react';

type HamburgToggleProps = {
  isOpen: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const HamburgToggle: React.FC<HamburgToggleProps> = (props) => {
  const { onClick, isOpen } = props;

  return (
    <button
      aria-controls="sidebar"
      onClick={onClick}
      className="z-99999 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
    >
      <span className="relative flex items-center h-5.5 w-5.5 cursor-pointer">
        <span className="block h-full w-full">
          <span
            style={{ height: '2px' }}
            className={`my-1 block w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${!isOpen && '!w-full delay-300'}`}
          />
          <span
            style={{ height: '2px' }}
            className={`my-1 block w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${!isOpen && '!w-full delay-300'}`}
          />
          <span
            style={{ height: '2px' }}
            className={`my-1 block w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${!isOpen && '!w-full delay-300'}`}
          />
        </span>
        <span className="absolute right-0 h-full w-full rotate-45">
          <span
            className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${!isOpen && '!h-0 !delay-[0]'}`}
          ></span>
          <span
            className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${!isOpen && '!h-0 !delay-200'}`}
          ></span>
        </span>
      </span>
    </button>
  );
};

export default HamburgToggle;
